export default __webpack_public_path__ + "static/media/logo-icon.ca4d5cb2.svg";